import { IResponse } from "models";

export enum ActionType {
  CONTRACT_INFORMATION_AUTO_RELEASE = "action/CONTRACT_INFORMATION_AUTO_RELEASE",
  CONTRACT_INFORMATION_AUTO_RELEASE_SUCCESS = "action/CONTRACT_INFORMATION_AUTO_RELEASE_SUCCESS",
  CONTRACT_INFORMATION_AUTO_RELEASE_ERROR = "action/CONTRACT_INFORMATION_AUTO_RELEASE_ERROR",
  CONTRACT_INFORMATION_AUTO_RELEASE_RESET = "action/CONTRACT_INFORMATION_AUTO_RELEASE_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IAutoReleasePayload {
  auto_release: boolean;
  days_until_auto_release: number;
}

export interface IAutoReleaseResponse extends IResponse {
  result: any;
}
